import { render, staticRenderFns } from "./personnelOverview_editPersonnelTraining.vue?vue&type=template&id=bb1cc8c2&scoped=true&"
import script from "./personnelOverview_editPersonnelTraining.vue?vue&type=script&lang=js&"
export * from "./personnelOverview_editPersonnelTraining.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1cc8c2",
  null
  
)

export default component.exports